import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from "axios"

const loadEventsFromLocalStorage = () => {
  const event = localStorage.getItem("event");
  return event ? JSON.parse(event) : null;
};




const initialState = {
  event:loadEventsFromLocalStorage(),
  loading: false,
  error: null
};

const coffeeSlice = createSlice({
  name: 'podcast',
  initialState,
  reducers: {
    setEvent: (state, action) => {
        state.event = action.payload;
        localStorage.setItem("event", JSON.stringify(action.payload));
    },
  
  

    
  },
 
    
});

export const {
    setEvent
} = coffeeSlice.actions;

export default coffeeSlice.reducer;